"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageUrl = void 0;
var imageUrl = function (src, w) {
    return "".concat(process.env.REACT_APP_API_URL, "/upload/optimized-delivery/").concat(w, "/").concat(src);
};
exports.imageUrl = imageUrl;
